import React, { useEffect } from "react";
import { connect } from "react-redux";
import ScrollIntoView from "../../../../shared/scroll-into-view/scroll-into-view";
import Loader from "./../../../../shared/loader";
import {
    fetchMakeupOverview,
    aliasMakeup,
    unaliasMakeup,
    deleteMultipleMakeups
} from "./ducks/actions";
import Overview from "./overview";

const OverviewContainer = (props) => {
    const filmId = props.match.params.filmId;
    const {
        fetchMakeupOverview,
        overview,
        loading,
        errors,
        warnings,
        aliasMakeup,
        unaliasMakeup,
        readOnly,
        onboardingSteps,
        processingMakeupIds,
        deleteMultipleMakeups
    } = props;

    useEffect(() => {
        fetchMakeupOverview(filmId);
    }, [filmId, fetchMakeupOverview]);

    function renderOverview(overview) {
        return (
            <ScrollIntoView
                className="blade-content wider"
                path="/films/:filmId/makeup/overview"
                loading={loading}>
                <h2 className="menu-label">Overview</h2>
                <Overview
                    overview={overview}
                    filmId={filmId}
                    errors={errors}
                    warnings={warnings}
                    aliasMakeup={aliasMakeup}
                    unaliasMakeup={unaliasMakeup}
                    readOnly={readOnly}
                    onboardingSteps={onboardingSteps}
                    processingMakeupIds={processingMakeupIds}
                    deleteMultipleMakeups={deleteMultipleMakeups}
                ></Overview>
            </ScrollIntoView>
        );
    }

    return (
        <>
            {(loading || !overview) && <Loader />}
            {!loading && overview && renderOverview(overview)}
        </>
    );
};

function mapStateToProps(state) {
    const { errors, warnings, overview, loading, readOnly, onboardingSteps, processingMakeupIds } =
        state.makeupOverviewState;
    return {
        errors,
        warnings,
        overview,
        loading,
        readOnly,
        onboardingSteps,
        processingMakeupIds
    };
}

export default connect(mapStateToProps, {
    fetchMakeupOverview,
    aliasMakeup,
    unaliasMakeup,
    deleteMultipleMakeups
})(OverviewContainer);
